export default "__VITE_ASSET__BQxSUaNx__"